/** Public contact and donation configuration for the support dialogs. */
export const SUPPORT_EMAIL = 'hieuphamdesdev@gmail.com';

/** Owner-supplied public receiving details; payment reconciliation is not connected. */
export const donationTransfer = {
  bankName: 'MB Bank — Ngân hàng TMCP Quân đội',
  accountName: 'PHAM DUC HIEU',
  accountNumber: '35555678967899',
  transferNote: 'Ung ho DesignForge',
  // Keep this path relative; appHref adds the root or GitHub Pages base once.
  qrAsset: 'assets/donate-vietqr.png',
} as const;

export const donationPayPal = {
  url: 'https://paypal.me/hyperdsquared',
} as const;
